export const getEventsListing = filter => `/v2/events?${filter}`;
export const isDownloadable = '/api/v1/events/summit/attendee/certificate/downloadable';
export const getEvent = event => `/v2/events/${event}`;
export const getMcdEvent = eventHashedId => `/api/v1/events/mcd/${eventHashedId}`;
export const findEvent = event => `/v1/events/${event}`;
export const mcdRegisterFree = eventId => `/api/v1/events/mcd/${eventId}/register/free`;
export const mcdRegisterNew = eventId => `/api/v1/events/mcd/${eventId}/register`;
export const mcdRegisterSingle = eventId => `/api/v1/events/mcd/${eventId}/register/single`;
export const mcdRegisterUpgrade = eventId => `/api/v1/events/mcd/${eventId}/register/upgrade`;
export const mcdRegisterRenewal = eventId => `/api/v1/events/mcd/${eventId}/register/renew`;
export const getEventFaqs = eventId => `/v1/events/${eventId}/faqs`;
export const getEventSpeakers = eventId => `/v2/events/${eventId}/speakers`;
export const getEventSessions = eventId => `/v2/events/${eventId}/sessions?include=speakers`;
export const getEventSponsors = eventId => `/v2/events/${eventId}/sponsors`;
export const getPublicEventFaqs = eventId => `/api/v1/events/${eventId}/faqs`;
export const getPublicEventSpeakers = eventId => `/api/v1/events/${eventId}/speakers`;
export const getPublicEventSessions = eventId => `/api/v1/events/${eventId}/sessions`;
export const getPublicEventSponsors = eventId => `/api/v1/events/${eventId}/sponsors`;
export const getPublicEventsListing = filter => `/api/v1/events?${filter}`;
export const findPublicEvent = event => `/api/v1/events/${event}`;
export const getEventTickets = eventId => `/v2/events/${eventId}/tickets`;
